var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDisplay && _vm.showRule !== "render"
    ? _c(
        "preview-form-item",
        {
          attrs: {
            labelText: _vm.labelName,
            labelWidth: _vm.labelWidth,
            labelPosition: _vm.labelPosition,
            textAlign: _vm.labelTextPosition,
            formType: _vm.formType,
            variableName: _vm.model,
            rules: _vm.validatorRule,
            paddingLeft: _vm.paddingLeft
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-item_input" },
            [
              _c("el-input", {
                style: { width: _vm.width },
                attrs: {
                  type: "textarea",
                  placeholder: _vm.placeholder,
                  clearable: _vm.isClearable,
                  disabled: _vm.isDisabled,
                  autosize: _vm.autosize,
                  "limit-length": _vm.textLength
                },
                model: {
                  value: _vm.currentModel,
                  callback: function($$v) {
                    _vm.currentModel = $$v
                  },
                  expression: "currentModel"
                }
              })
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a47f2e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a47f2e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_item/PreviewItemTextarea.vue
// module id = null
// module chunks = 